export type FieldControlKind =
  | 'text'
  | 'textarea'
  | 'number'
  | 'boolean'
  | 'date'
  | 'time'
  | 'datetime'
  | 'enum';

const CONTROL_KIND: Record<string, FieldControlKind> = {
  text: 'textarea',
  integer: 'number',
  float: 'number',
  numeric: 'number',
  currency: 'number',
  boolean: 'boolean',
  date: 'date',
  time: 'time',
  datetime: 'datetime',
  enum: 'enum',
};

export function fieldControlKind(
  fieldType: string | undefined,
): FieldControlKind {
  if (!fieldType) return 'text';
  return CONTROL_KIND[fieldType] ?? 'text';
}

export type ParsedFieldDraft = { ok: true; value: unknown } | { ok: false };

/** Empty text clears the field (null). An unparsable number does not commit. */
export function parseFieldDraft(
  kind: FieldControlKind,
  fieldType: string | undefined,
  draft: string,
): ParsedFieldDraft {
  if (kind === 'number') return parseNumberDraft(fieldType, draft);
  if (draft === '') return { ok: true, value: null };
  return { ok: true, value: draft };
}

function parseNumberDraft(
  fieldType: string | undefined,
  draft: string,
): ParsedFieldDraft {
  const trimmed = draft.trim();
  if (trimmed === '') return { ok: true, value: null };
  const value = Number(trimmed);
  if (!Number.isFinite(value)) return { ok: false };
  if (fieldType === 'integer' && !Number.isInteger(value)) return { ok: false };
  return { ok: true, value };
}

export function formatFieldDraft(
  value: unknown,
  kind: FieldControlKind,
): string {
  if (value == null) return '';
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (typeof value !== 'string') return '';
  if (kind === 'date') return value.slice(0, 10);
  if (kind === 'datetime') return value.slice(0, 16);
  return value;
}

export function numberInputStep(fieldType: string | undefined): string {
  return fieldType === 'integer' ? '1' : 'any';
}
